import React, { useContext } from 'react';
import { Link as RouterLink, NavLink } from 'react-router-dom';
import { Link, LinkBaseProps, LinkProps } from '@mui/material';
import { BlockNavigationContext } from '../contexts/BlockNavigationProvider';

export type BasicLinkProps = {
  external?: boolean;
} & LinkBaseProps &
  LinkProps<typeof NavLink | typeof RouterLink | 'a', { component?: typeof NavLink | typeof RouterLink }>;

export const BasicLink = ({ external, children, component = RouterLink, ...linkProps }: BasicLinkProps) => {
  const { handler } = useContext(BlockNavigationContext);

  return (
    <Link
      color="primary"
      onClickCapture={handler} // this makes sure that blocked navigation is handled before navigation in the link
      underline="hover"
      component={external ? 'a' : component}
      {...linkProps}
    >
      {children}
    </Link>
  );
};
